import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
import { CTAButton } from '../ui/CTAButton';
export function FinalCTA() {
  return <section className="py-32 px-6 relative overflow-hidden" data-id="element-66">
      {/* Decorative background */}
      <div className="absolute inset-0 bg-teal-900" data-id="element-67"></div>
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-full bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-teal-800 via-teal-900 to-teal-900" data-id="element-68"></div>

      <div className="max-w-3xl mx-auto relative z-10 text-center" data-id="element-69">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-70">
          <h2 className="text-4xl md:text-5xl lg:text-6xl text-cream mb-8" data-id="element-71">
            Reserva tu lugar <span className="italic text-gold" data-id="element-72">gratuito</span>{' '}
            ahora
          </h2>

          <div className="flex items-center justify-center gap-3 text-cream/90 mb-12 text-lg" data-id="element-73">
            <Gift className="w-6 h-6 text-terracotta" data-id="element-74" />
            <p data-id="element-75">
              Accede al entrenamiento + recibe el Ebook F.O.D.A completamente
              GRATIS.
            </p>
          </div>

          <div className="flex justify-center" data-id="element-76">
            <CTAButton data-id="element-77" />
          </div>

          <div className="mt-10 flex items-center justify-center gap-2 text-terracotta font-medium text-sm" data-id="element-78">
            <span className="text-lg" data-id="element-79">⚠</span> Cupos limitados para la próxima
            clase en vivo.
          </div>
        </motion.div>
      </div>
    </section>;
}